export default "__VITE_ASSET__DEFiXYSb__"